[
  {
    "code": "SL-E",
    "name": "Eastern"
  },
  {
    "code": "SL-N",
    "name": "Northern"
  },
  {
    "code": "SL-S",
    "name": "Southern"
  },
  {
    "code": "SL-W",
    "name": "Western Area (Freetown)"
  }
]